import Vue from 'vue'
import Vuex from 'vuex'
import './../plugins/vue-axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    request: (store, options) => {
      return new Promise((resolve, reject) => {
        Vue.axios({ url: options.uri, ...options }).then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
  }
})
